<ng-container *ngIf="applyGlobalFilters && (entities?.length || filters?.length)">

    <div *ngIf="mode == 'default'" (click)="logData([filters, entities])"
        [ngClass]="{'innerPage px-10 break-before':seperatePage}" class=" bg-white avoidBreak">
        <div class="exportContainer pt-20  gap-10 flex flex-col">
            <h1 [ngClass]="!seperatePage?'text-sm':'text-2xl'" class="text-zen font-semibold"><span *ngIf="seperatePage"
                    class="text-exp">{{index}}.
                </span>{{ "AppliedFilters" | translate:language:ModuleNames.Shared }}
            </h1>
            <!-- content -->
            <div class="flex flex-col items-start justify-between">
                <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
            </div>
        </div>
    </div>

    <div *ngIf="mode =='partial'"
        class="flex flex-col items-stretch p-4 gap-4 border border-zen border-opacity-10 rounded-lg">
        <h5 class="uppercase font-medium text-zen text-opacity-60 text-xs">{{ "AppliedFilters" |
            translate:language:ModuleNames.Shared }}</h5>
        <ng-container *ngTemplateOutlet="filtersTemplate"></ng-container>
    </div>
</ng-container>


<ng-template #filtersTemplate>
    <div class="flex flex-col gap-2">
        <div class="flex flex-row items-start gap-4 w-full" *ngFor="let entity of entities let i=index">
            <div
                class="flex flex-row items-center gap-1 text-xs text-exp font-medium min-w-input whitespace-normal break-words">
                <span class="roundIcon bg-exp bg-opacity-10 leading-5 text-center">{{entity?.nodes?.length}}</span>
                <span class="capitalize">{{entity.name| extract:language}}</span>
            </div>
            <div class="flex flex-row flex-wrap -mr-1 -ml-1 text-xs font-medium">
                <div class="flex text-zen px-1 pb-1" *ngFor="let node of entity?.nodes let z=index">
                    <span class="bg-zen bg-opacity-10 rounded-r-full rounded-l-full  leading-5 px-2">{{node.name
                        |
                        extract:language}}</span>
                </div>
            </div>


        </div>
        <div class="flex flex-row items-start gap-4 w-full" *ngFor="let filter of filters; let i=index">
            <div
                class="flex flex-row items-center gap-1 text-xs text-exp font-medium min-w-input whitespace-normal break-words">
                <span class="roundIcon bg-exp bg-opacity-10 leading-5 text-center">{{filter.value?.length}}</span>
                <span class="capitalize">{{(filter.name| extract:language) ||
                    (filter.name|
                    translate:language:ModuleNames.Shared)}}</span>
            </div>
            <div class="flex flex-row flex-wrap -mr-1 -ml-1 text-xs font-medium">
                <ng-container *ngFor="let option of filter.validOptions; let z=index">
                    <div *ngIf="filter.value?.includes(option.key)" class="flex text-zen px-1 pb-1">
                        <span class="bg-zen bg-opacity-10 rounded-r-full rounded-l-full leading-5 px-2">{{filter.key
                            !=
                            'PerformanceRate'? (option.name
                            |extract:language):option.value}}</span>
                    </div>
                </ng-container>
            </div>


        </div>
    </div>
</ng-template>